module.exports = __webpack_public_path__ + "static/media/web-design-most-outstanding.d4b01e94.jpg";